import LoginForm from '@components/templetes/Login/LoginForm';

const Login = () => {
  return <LoginForm />;
};

export default Login;
